import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'ras-stand-alone-interactive-view-banner',
  templateUrl: './stand-alone-interactive-view-banner.component.html',
  styleUrls: ['./stand-alone-interactive-view-banner.component.sass']
})
export class  StandAloneInteractiveViewBannerComponent implements OnInit {
  @Output() generic_sizes = new EventEmitter<null|string[]>();
  @Output() generic_areas = new EventEmitter<null|string[]>();
  @Output() small = new EventEmitter<null|number>();
  @Output() medium = new EventEmitter<null|number>();
  @Output() large = new EventEmitter<null|number>()

  generic_unit_sizes: null|string[] = null
  generic_unit_areas: null|string[] = null

  constructor() { }

  ngOnInit(): void {
    
  }

  populate_generic_unit_sizes (category){

    this.generic_unit_sizes = [",9x,9","1,3x1","1,5x2","2x2",
    "4x2,5","3x3","3,4x3,8","4x4,5",
    "4x7","5x6","6x9"]
    this.generic_unit_areas = ["0.81","4,5","3","4",
    "10","9","12.92","16",
    "25","30","54"]
    
    this.generic_sizes.emit(this.generic_unit_sizes)

    this.generic_areas.emit(this.generic_unit_areas)
   
    if(category==1){
      this.small.emit(2)
    }else if(category == 2){
      this.medium.emit(5)
    }else{
      this.large.emit(8)
    }

    
    
    
    //console.log(this.generic_sizes,this.generic_areas)
  }
    
}
